import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { verifyToken } from "store/actions/authSlice";
import { showAlert } from "store/reducers/alertReducer";
import Spinners from "components/common/Spinners";

const AcceptOrganisationInvitation = () => {
  // const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const redirectTo = queryParams.get("redirectTo");

  const { isLoading } = useSelector((state) => state.auth);

  const calledOnce = useRef(false); // ✅ prevent duplicate calls

  useEffect(() => {
    if (calledOnce.current) return; // skip if already called
    calledOnce.current = true;

    if (token) {
      dispatch(verifyToken({ token }))
        .then((action) => {
          const { statusCode, success, message } = action?.payload || {};
          if (statusCode === 200 && success) {
            dispatch(showAlert({ text: message, type: "success" }));
            localStorage.setItem("invitation_token", token);
            navigate(
              redirectTo
                ? `/set-new-password?redirectTo=${redirectTo}`
                : "/set-new-password"
            );
          } else {
            dispatch(showAlert({ text: message, type: "error" }));
          }
        })
        .catch(() => {
          dispatch(showAlert({ text: "Something went wrong", type: "error" }));
        });
    } else {
      console.log("No token found in URL path.");
    }
  }, [token, dispatch]);

  return (
    <div className="welcome_pg">
      <Spinners />
      <div className="container position-relative">
        <div className="tcp_inner">
          <div className="left"></div>
        </div>
      </div>
    </div>
  );
};

export default AcceptOrganisationInvitation;
